import type { BadgeVariant } from '@/lib/enum-utils'

export function badgeVariantToTailwind(variant: BadgeVariant): string {
  switch (variant) {
    case 'default':
    case 'secondary':
      return 'bg-muted-foreground'
    case 'success':
      return 'bg-status-success-fg'
    case 'warning':
      return 'bg-status-warning-fg'
    case 'danger':
      return 'bg-status-danger-fg'
    case 'info':
      return 'bg-status-info-fg'
    case 'purple':
      return 'bg-purple-400'
    case 'pink':
      return 'bg-pink-400'
    case 'orange':
      return 'bg-orange-400'
    default:
      return 'bg-muted-foreground'
  }
}
